<div class="empty-node-editor" *ngIf="condition">
</div>